'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import PropTypes from 'prop-types'

var Link = function Link(_ref) {
  var href = _ref.href,
      active = _ref.active,
      children = _ref.children,
      _onClick = _ref.onClick,
      selected = _ref.selected,
      disabled = _ref.disabled;

  if (active) {
    return (0, _preact.h)(
      'span',
      null,
      children
    );
  }
  var className = disabled ? 'disabled' : selected ? 'selected' : '';
  return (
    // eslint-disable-next-line
    (0, _preact.h)(
      'a',
      { href: href || '#',
        'class': className,
        onClick: function onClick(e) {
          e.preventDefault();
          _onClick();
        }
      },
      children
    )
  );
};

// Link.propTypes = {
//   active: PropTypes.bool.isRequired,
//   children: PropTypes.node.isRequired,
//   onClick: PropTypes.func.isRequired
// }

exports.default = Link;


//////////////////
// WEBPACK FOOTER
// ./client/components/UI/Link.jsx
// module id = 17
// module chunks = 0